export class ContactUsForm {
    
    constructor(private name:string, private email:string, private cellphone:string, private message:string)
    {        
    }
}


// WEBPACK FOOTER //
// J:/Develop/Plumit Maintenance/src/app/contact-us/contact-us.ts